import React, { useRef, useEffect } from "react";
import { observer } from "mobx-react";

import "./article-card.scss";
import { useElementHeight } from "../../hooks/index";
import { isMobile } from "../../utils/tools";

interface Props {
  activeId?: string;
  slug: string;
  children: React.ReactNode;
  className?: string;
  hoveredIndex: number | null;
  index: number;
  initTop?: number;
}

const ArticleCard: React.FC<Props> = (props: Props) => {
  const { activeId, slug, children, hoveredIndex, index = 0 } = props;
  const ref = useRef(null);

  const getHeight = () => {
    if (ref.current) {
      const { height } = ref.current.getBoundingClientRect();
      return height;
    }
    return 0;
  };

  const getTop = () => {
    const child = ref.current;
    const parent = document.querySelector(".home__list");
    const childRect = child.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const topRelativeToParent = childRect.top - parentRect.top;
    return topRelativeToParent;
  };

  const reset = hoverBlock => {
    hoverBlock.style.transition = "unset";
    hoverBlock.style.zIndex = "-1";
    hoverBlock.style.top = 0;
  };

  useElementHeight((height: number) => {
    if (isMobile()) return false;
    if (index === hoveredIndex) {
      const hoverBlock: HTMLElement = document.querySelector(`.hover-block`);
      hoverBlock.style.height = `${height}px`;
    }
  }, ref);

  useEffect(() => {
    if (isMobile()) return () => {};
    const hoverBlock: HTMLElement = document.querySelector(`.hover-block`);
    if (index === hoveredIndex) {
      const top = getTop();
      const height = getHeight();

      if (hoveredIndex !== null) {
        hoverBlock.style.transition =
          hoverBlock.style.zIndex === "-1" ? "unset" : "all 0.3s";
        hoverBlock.style.height = `${height}px`;
        hoverBlock.style.zIndex = "1";
        hoverBlock.style.top = top + "px";
      } else {
        reset(hoverBlock);
      }
    } else {
      if (hoveredIndex === null) reset(hoverBlock);
    }
  }, [hoveredIndex]);

  return (
    <div
      className={`article-card ${activeId &&
        "article-card--detail"} ${activeId === slug && "article-card--active"}`}
      ref={ref}
    >
      {children}
    </div>
  );
};

export default observer(ArticleCard);
